import React from "react";
import PropTypes from "prop-types";
import { user as userType } from "api/users/types";
import { Link } from "react-router-dom";
import i8a from "assets/images/i8a.svg";
import i9a from "assets/images/i9a.svg";
import i35 from "assets/images/i35.svg";
import Select from "components/form/select";
import { css } from "react-emotion";
import i78 from "assets/images/i78.svg";
import { Trans, withTranslated } from "components";

const propTypes = {
  user: userType.isRequired,
  changeLanguage: PropTypes.func.isRequired
};

class ProfilePopup extends React.Component {
  render() {
    const { user, t } = this.props;

    return (
      <div className="nav-toppanel--user-profile-dropdown">
        <div className="nav-toppanel--user-profile-person">
          <div className="avatar-outer--md-box a-bg-25">
            <div className="avatar-inner-md-box">{user.initials}</div>
          </div>
          <div className="nt--user-name">{user.full_name}</div>
        </div>
        <div className="nav-toppanel--profile-link-list">
          <div className="nav-toppanel--profile-link">
            <Link to="/my-profile/details">
              <span className="nt-profile-link--icon">
                <img src={i8a} alt="" />
              </span>
              <span><Trans>Ustawienia profilu</Trans></span>
            </Link>
          </div>
          <div className="nav-toppanel--profile-link">
            <Link to="/my-profile/password-set">
              <span className="nt-profile-link--icon">
                <img src={i9a} alt="" />
              </span>
              <span><Trans>Zmiana hasła</Trans></span>
            </Link>
          </div>
          <div className="nav-toppanel--profile-link">
            <Select.Control
              name="lang"
              onChange={this.props.changeLanguage}
              selectedClass={selectedClass}
              img={i78}
              placeholder={t("Wybierz język")}
            >
              <Select.Option value="pl" label="Polski" />
              <Select.Option value="en" label="English" />
            </Select.Control>
            {/* <div className="form-field">
              <span className="select-type-icon">
                <img src="images/i78.svg" alt="" />
              </span>
              <div className="select-wrapper">
                <div className="select-field">
                  <div className="select-option-list">
                    <div className="select-option">Polski</div>
                    <div className="select-option">Angielski</div>
                    <div className="select-option">Francuski</div>
                  </div>
                </div>
                <label className="label" for="">
                  Wybierz język
                </label>
                <span className="error-ms" />
              </div>
            </div> */}
          </div>
        </div>
        <div>
          <div className="btn-container btn-container--btns-on-center">
            <Link to="/logout" className="stroke-btn" type="submit">
              <span><Trans>Wyloguj się</Trans></span>
              <span className="nt-profile-btn--icon-r">
                <img src={i35} alt="" />
              </span>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}

ProfilePopup.propTypes = propTypes;
export default withTranslated(ProfilePopup);

const selectedClass = css`
  opacity: 0.4;
  :hover {
    background-color: initial;
  }
`;



// WEBPACK FOOTER //
// ./src/partialComponents/panelWrapper/subcomponents/ProfilePopup.jsx